import { Card } from '@sonnen/web-ui';
import { PropsWithChildren } from 'react';
import styles from './SideCard.module.css';

export const SideCard = ({
  children,
  dataTestId,
}: PropsWithChildren & {
  dataTestId?: string;
}) => {
  return (
    <div data-testid={dataTestId}>
      <Card paddingSize="md" className={styles.sideCard} dataTestId="side">
        {children}
      </Card>
    </div>
  );
};
